import { MUIButton, Notification } from '@abb/arcadia-ui-react';
import * as ActionCreators from '@module/license/actionCreators/licenseAllowanceActionCreators';
import { API_ERROR_MESSAGE, API_SUPPORT_EMAIL } from '@service/constants';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from '@module/shared/routerCompat';
import { IConnectedComponent } from '../../../../../reducers';
import { Allocation, ILicensableService, ILicenseAllowance } from '../../../models';
import { default as LicenseAllowanceTable } from './LicenseAllowanceTable';

/* tslint:disable:no-empty jsx-no-lambda jsx-self-close*/
export class LicenseAllowanceTableContainer extends React.Component<ILicenseAllowanceTableContainerProps & IConnectedComponent, any> {
  constructor(props: ILicenseAllowanceTableContainerProps & IConnectedComponent) {
    super(props);
    this.state = {
      allocationToAdd: new Allocation(),
      // TODO: grab initial value for service dropdown from this.props.serviceOptions for allocationToAdd product name and productNameBeingEdited
      productNameBeingEdited: { label: '', value: null }
    };
  }
  render() {
    const errorMessage =
      <div hidden={!this.props.licenseAllowanceErrorMessageVisible}>
        <Notification variant='error' isBanner={true} open={this.props.licenseAllowanceErrorMessageVisible} id='errorBanner'
          primaryText={API_ERROR_MESSAGE} secondaryText={API_SUPPORT_EMAIL}
          onClose={() => { this.props.clearErrorMessage(); }} />
      </div>;

    const canAddService = this.props.serviceOptions.licensableServices.length > 0 && !this.props.allocationIsEditing;
    const button = this.props.userPermissions?.isAdmin
    ? (
      <div className='col-md-4 text-right align-bottom button-top-buffer'>
        <MUIButton variant='secondary' size={32} iconName='icon_abb_dias icon-abb_add' label='Add Service' disabled={!canAddService} onClickButton={() => { this.handleAddNewEditableRow(this.props.licenseAllowances, this.props.match.params.siteId); }} />
      </div>
      )
    : null;

    return (
      <div className='container app-content-div container-style card-container'>
        <div className='row toolbar bottom-buffer'>
          <div className='col-md-8'>
            <h3>License Allowances</h3>
          </div>
          {button}
        </div>
        {errorMessage}
        <div className='bs'>
          <div className='row'>
            <div className='col-md-12'>
              <LicenseAllowanceTable {...this.props}></LicenseAllowanceTable>
            </div>
          </div>
        </div>
      </div>
    );
  }

  handleAddNewEditableRow(licenseAllowances: ILicenseAllowance[], siteId: number) {
    // not positive how to access the serviceOptions list from my constructor below so I am updating the product and asset type here before adding the new row
    const initialService = this.getInitialProductName(this.props.serviceOptions.licensableServices, this.props.licenseAllowances);
    this.setState((prevState: any) => ({
      allocationToAdd: {
        ...new Allocation(),
        licensableService: {
          productName: initialService.productName,
          assetType: initialService.assetType,
          licenseParameters: '',
          licensePassword: '',
          id: 0,
        }
      },
      productNameBeingEdited: {
        ...prevState.productNameBeingEdited,
        label: initialService.productName,
        value: initialService.assetType.id
      },
      serviceBeingEdited: {
        ...prevState.serviceBeingEdited,
        productOrderNumber: {
          value: '',
          valid: false
        }
      }
    }));
    this.props.AddNewEditableRow(licenseAllowances, siteId);
  }

  getInitialProductName(services: ILicensableService[], licenseAllowances: ILicenseAllowance[]): ILicensableService {
    for (const service of services) {
      if (!this.props.licenseAllowances.find((x: any) => x.licensableService.productName === service.productName)) {
        return service;
      }
    }
    return { id: -1, assetType: { id: -1, assetTypeName: '' }, licenseParameters: '', licensePassword: '', productName: '' };
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(LicenseAllowanceTableContainer) as any);

export function mapStateToProps(store: any) {
  const { access_token: accessToken } = store.userState.loggedInUser;
  return { ...store.servicesState, ...store.serviceOptionsState, ...store.serverState, userPermissions: store.userState.userPermissions, accessToken };
}

function mapDispatchToProps(dispatch: any) {
  return {
    addAllocation: (allocation: ILicenseAllowance, accessToken: string) =>
      dispatch(ActionCreators.onAddAllocation(allocation, accessToken)),
    AddNewEditableRow: (allocations: ILicenseAllowance[], siteId: number, accessToken: string) =>
      dispatch(ActionCreators.onAddNewEditableRow(allocations, siteId, accessToken)),
    EditExistingRow: (allocation: ILicenseAllowance, siteId: number, accessToken: string) =>
      dispatch(ActionCreators.onEditExistingRow(allocation, siteId, accessToken)),
    CancelAllocationEdit: (allocation: ILicenseAllowance) =>
      dispatch(ActionCreators.onCancelAllocationEdit(allocation)),
    UpdateAllocation: (allocation: ILicenseAllowance, accessToken: string) =>
      dispatch(ActionCreators.onUpdateAllocation(allocation, accessToken)),
    DeleteAllocation: (allocation: ILicenseAllowance, siteId: number, accessToken: string) =>
      dispatch(ActionCreators.onDeleteAllocation(allocation, siteId, accessToken)),
    CancelAddAllocation: () => dispatch(ActionCreators.onCancelAddAllocation()),
    clearErrorMessage: () => dispatch(ActionCreators.clearErrorMessage())
  };
}

function mergeProps({ accessToken, ...propsFromState }: any, { addAllocation, AddNewEditableRow, EditExistingRow, CancelAllocationEdit, UpdateAllocation, DeleteAllocation, clearErrorMessage, ...propsFromDispatch }: any, ownProps: any) {
  return {
    ...propsFromState,
    ...propsFromDispatch,
    ...ownProps,
    addAllocation: (allocation: ILicenseAllowance) => addAllocation(allocation, accessToken),
    AddNewEditableRow: (allocations: ILicenseAllowance[], siteId: number) => AddNewEditableRow(allocations, siteId, accessToken),
    EditExistingRow: (allocation: ILicenseAllowance, siteId: number) => {
      EditExistingRow(allocation, siteId, accessToken);
    },
    CancelAllocationEdit: (allocation: ILicenseAllowance) => {
      CancelAllocationEdit(allocation);
    },
    UpdateAllocation: (allocation: ILicenseAllowance) => UpdateAllocation(allocation, accessToken),
    DeleteAllocation: (allocation: ILicenseAllowance, siteId: number) => DeleteAllocation(allocation, siteId, accessToken),
    clearErrorMessage: () => clearErrorMessage()
  };
}

export interface ILicenseAllowanceTableContainerProps {
  licenseAllowances: ILicenseAllowance[];
  site: any;
  serviceOptions: any;
  requestServices: any;
  addAllocation: any;
  AddNewEditableRow: any;
  EditExistingRow: any;
  CancelAllocationEdit: any;
  UpdateAllocation: any;
  DeleteAllocation: any;
  CancelAddAllocation: any;
  RequestServiceTypes: any;
  allocationIsAddingNew: boolean;
  allocationIsEditing: boolean;
  match: any;
  server: any;
  renderServiceTypeComboBoxCol: any;
  permissions: string[];
  errorMessage: string;
  clearErrorMessage: any;
  licenseAllowanceErrorMessageVisible: boolean;
}
